<div class="v3-member-list">
  <ptl-data-table
    [columns]="tableColumns"
    [data]="members"
    [loading]="isLoaderActive"
    [trackKey]="'_id'"
    [darkHeader]="true"
    [serverSide]="true"
    [totalItems]="membersTotalCount"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [sort]="tableSort"
    [selectable]="isColumnEnabled('SELECT')"
    [selectedKeys]="selectedMemberIds"
    [selectAllAriaLabel]="
      allUsersChecked
        ? ('translations.global.ariaLabels.uncheckAllUsers' | transloco)
        : ('translations.global.ariaLabels.checkAllUsers' | transloco)
    "
    (selectedKeysChange)="onSelectedKeysChange($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChangeEvent($event)"
    (pageSizeChange)="onSizeChange($event)"
    (rowClick)="openUserRecordByUid($event)"
  >
    <ng-template ptlCell="firstName" let-row>
      <div class="v3-member-list__name-cell">
        @if (row.imageUrl) {
          <img class="v3-member-list__avatar v3-member-list__avatar--image" [src]="row.imageUrl" [alt]="row.firstName" />
        } @else {
          <div class="v3-member-list__avatar" aria-hidden="true">
            {{ getMemberInitials(row.firstName, row.lastName) }}
          </div>
        }
        <span class="v3-member-list__name" matTooltip="{{ row.firstName }}" matTooltipClass="medium-tooltip">
          {{ row.firstName }}
        </span>
      </div>
    </ng-template>

    <ng-template ptlCell="lastName" let-row>
      <span class="v3-member-list__last-name" matTooltip="{{ row.lastName }}" matTooltipClass="medium-tooltip">{{ row.lastName }}</span>
    </ng-template>

    <ng-template ptlCell="email" let-row>
      <span class="v3-member-list__ellipsis" matTooltip="{{ row.email }}" matTooltipClass="medium-tooltip">{{ row.email }}</span>
    </ng-template>

    <ng-template ptlCell="roles" let-row>
      @if (row.roles?.length) {
        <ptl-pill color="grey" size="s">{{ getRoleLabel(row.roles) }}</ptl-pill>
      }
    </ng-template>

    <ng-template ptlCell="groups" let-row>
      @if (row.groups?.length) {
        <span class="v3-member-list__ellipsis" [matTooltip]="showExpandedContent(row, 'GROUPS')" matTooltipClass="medium-tooltip">
          {{ row.groups[0].title }}
        </span>
      }
    </ng-template>

    <ng-template ptlCell="lastActiveOn" let-row>
      <span class="v3-member-list__date" [matTooltip]="row.lastActiveOn ? (row.lastActiveOn | ptlDate: 'dateTime') : ''">{{
        row.lastActiveOn | smartDateFormat
      }}</span>
    </ng-template>

    <ng-template ptlCell="createdAt" let-row>
      <span class="v3-member-list__date" [matTooltip]="row.createdAt ? (row.createdAt | ptlDate: 'dateTime') : ''">{{
        row.createdAt | ptlDate: 'date'
      }}</span>
    </ng-template>

    <ng-template ptlCell="status" let-row>
      @let active = isMemberActive(row);
      <span class="v3-member-list__status" [attr.data-state]="active ? 'active' : 'inactive'">
        <span class="v3-member-list__status-dot"></span>
        @if (active) {
          {{ 'translations.global.label.active' | transloco }}
        } @else {
          {{ 'translations.global.label.inactive' | transloco }}
        }
      </span>
    </ng-template>

    <ng-template ptlCell="actions" let-row>
      <mat-menu #memberMenu="matMenu" xPosition="before" class="v3-roles-row-menu">
        <button mat-menu-item type="button" (click)="openUserRecordByUid(row)">
          {{ 'translations.global.button.open' | transloco }}
        </button>
      </mat-menu>
      <button
        class="v3-member-list__row-more"
        type="button"
        [matMenuTriggerFor]="memberMenu"
        (click)="$event.stopPropagation()"
        [attr.aria-label]="'translations.global.ariaLabels.openUserRecord' | transloco: { title: row.firstName + ' ' + row.lastName }"
      >
        <ptl-icon [icon]="LucideEllipsisVertical" [size]="'s'"></ptl-icon>
      </button>
    </ng-template>

    <ptl-v3-empty-state
      table-empty
      [icon]="LucideUsers"
      [title]="'translations.membersNew.list.table.noUsersFound' | transloco"
      [description]="'translations.membersNew.list.table.noUsersFoundDescription' | transloco"
    ></ptl-v3-empty-state>
  </ptl-data-table>
</div>
